import { render } from "./RecipeSuggested.vue?vue&type=template&id=22491dc2&scoped=true"
import script from "./RecipeSuggested.vue?vue&type=script&lang=js"
export * from "./RecipeSuggested.vue?vue&type=script&lang=js"

import "./RecipeSuggested.vue?vue&type=style&index=0&id=22491dc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22491dc2"]])

export default __exports__